import { action, makeObservable, observable, runInAction } from 'mobx';
import { DefaultFormFields, FormControl, FormController } from '@insurancemenu/imenu-components-lib/dist/utils/forms';
import { GroupStore } from 'store/domain/groupStore';

interface NotesFields extends DefaultFormFields {
  notes: FormControl<string>;
}

export class GroupNotesModalStore {
  groupStore: GroupStore;
  notesForm: FormController<NotesFields>;

  loading = false;

  public async saveGroupNotes(groupId?: string): Promise<void> {
    this.loading = true;
    await this.groupStore.saveNotesToGroup(
      groupId || this.groupStore.group.id,
      this.notesForm.fields.notes.value.trim(),
    );
    runInAction(() => {
      this.loading = false;
    });
  }

  public updateFormWithData(notes: string): void {
    this.notesForm.populateFields({ notes });
  }

  constructor(groupStore: GroupStore) {
    this.groupStore = groupStore;

    this.notesForm = new FormController({
      notes: new FormControl<string>(''),
    });

    makeObservable(this, {
      notesForm: observable,
      loading: observable,
      saveGroupNotes: action.bound,
      updateFormWithData: action.bound,
    });
  }
}
